import type { Api, DataImport, Vendor } from '@cruz-com/lookup'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function locations(params: object): Promise<Api.Result<(Vendor.Location & DataImport.Location)[]>> {
  try {
    const headers = await getHeader()
    const res = await fetch(`${baseURL}/carsforsale-import/locations?${new URLSearchParams(params as Record<string, string>)}`, {
      method: 'GET',
      headers,
      cache: 'no-store',
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
